import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Layout from "./layout";
import SearchIcon from "@mui/icons-material/Search";
import TableSortLabel from "@mui/material/TableSortLabel";
import DownloadIcon from "@mui/icons-material/Download";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { jsPDF } from "jspdf";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions, DialogContentText } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import "jspdf-autotable";
import "../App.css";
import CreateProduct from "./CreateIssueProduct";
import issueProductIcon from "../images/issueProduct.png";
import editProductIcon from "../images/editProduct.png";
import returnProductIcon from "../images/returnProduct.png";
import Tooltip from "@mui/material/Tooltip";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import ReturnProduct from "./ReturnProduct";
import { CircularProgress } from "@mui/material";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useAcademicYear } from "./AcademicYearContext";
import InfoIcon from "@mui/icons-material/Info";
import { getInstituteConfig } from "../utility/instituteConfig";

export default function IssueProduct() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("issue_product_id");
  const [roleName, setRoleName] = useState("");
  const [data, setData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [product, setProduct] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedIssueProductId, setSelectedIssueProductId] = useState(null);
  const [openComponent, setOpenComponent] = useState(false);
  const [staffId1, setStaffId1] = useState("");
  const [staffName, setStaffName] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [dialogType, setDialogType] = useState(""); // Add this line
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [refundedStatusId, setRefundedStatusId] = useState(null);
  const [saleStatus, setSaleStatus] = useState([]);
  const [userId, setUserId] = useState();
  const [totalStockQuantity, setTotalStockQuantity] = useState([]); // Initialize appropriately
  const [totalQuantity, setTotalQuantity] = useState([]); // Initialize appropriately
  const [totalProduct, setTotalProduct] = useState([]); // Initialize as needed
  const [deleteFlag, setDeleteFlag] = useState(false);
  const [deleteData, setDeleteData] = useState([]);
  const [statusName, setStatusName] = useState("");
  const [statusId, setStatusId] = useState(undefined);
  const [openComponentCreateSale, setOpenComponentCreateSale] = useState(false);
  const [openComponentRefundSale, setOpenComponentRefundSale] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessageForReturn, setDialogMessageForReturn] = useState("");
  const [statusCreatedId, setStatusCreatedId] = useState();
  const [needsReturn, setNeedsReturn] = useState(false);
  const [descriptions, setDescriptions] = useState("");
  const [IssueDescriptions, setIssueDescriptions] = useState("");
  const [SelectedEventId, setSelectedEventId] = useState(null);
  const [createdStatusId, setCreatedStatusId] = useState(null);
  const [description, setDescription] = useState(""); // use only this

  const instituteId = localStorage.getItem("instituteId");

  // Check if any product in the selected issue has "Partial Return"
  const hasPartialReturn = product.some(
    (p) =>
      p.issue_product_id === selectedIssueProductId &&
      p.type === "Partial Return",
  );

  const handleClick = (row) => {
    if (row.description === "Issued" || row.description === "Partial Return") {
      handleOpenComponentRefundSale(row); // Open refund sale component
    } else if (row.description === "Created") {
      setDialogMessageForReturn(
        "Cannot return. Your products have not been issued yet.",
      );
      setOpenDialog(true);
    } else if (row.description === "Returned") {
      setDialogMessageForReturn("Your products are already returned.");
      setOpenDialog(true);
    }
  };

  const navigate = useNavigate();

  const { academicYearId } = useAcademicYear();

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);

  const handleRTEChange = () => {
    setNeedsReturn(!needsReturn);
  };

  useEffect(() => {
    getSales();
  }, [academicYearId]);

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          console.log("response", response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      console.log("Fetched data:", data);

      // Extract specific sale_status_id for descriptions "Paid" and "Issued"

      const issuedStatus =
        data.find((item) => item.description === "Issued")
          ?.issue_product_status_id || null;
      const refundedStatus =
        data.find((item) => item.description === "Returned")
          ?.issue_product_status_id || null;

      console.log("Issued Sale Status ID:", issuedStatus);

      // Set the complete data and the extracted IDs in state
      setSaleStatus(data);
      setIssuedStatusId(issuedStatus);
      setRefundedStatusId(refundedStatus);
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  useEffect(() => {
    // Reset deleteData when the component mounts
    setDeleteData([]);
    getProduct(); // Fetch products after resetting state
  }, []);

  useEffect(() => {
    console.log("Current deleteData:", deleteData);
  }, [deleteData]);

  const handleOpenComponentCreateSale = () => {
    setOpenComponentCreateSale(true);
    setIssueDescriptions(""); // ✅ Add this line to clear the description
    setStaffId1(""); // Also clear staff details for new creation
    setStaffName("");
    setSelectedIssueProductId(null); // Clear selected ID
    getSales();
  };
  const handleOpenComponentRefundSale = (row) => {
    setStaffId1(row.issued_to_staff_id || "Unknown ID");
    setStaffName(`${row.first_name || ""} ${row.last_name || ""}`);
    setRoleName(row.role_name);
    setSelectedEventId(row.issue_product_id);

    setSelectedIssueProductId(row.issue_product_id);
    setOpenComponentRefundSale(true);
    getSales();
  };
  useEffect(() => {
    console.log("selected decription ssssss", IssueDescriptions);
  }, [IssueDescriptions]);

  const handleOpenComponent = (row) => {
    console.log("ro", row);

    let issueDescToShow = "";
    let createdRecordId = null; // ✅ Add this to track the Created record ID

    if (row.description === "Created") {
      // ✅ Case 1: Created → use its own description and ID
      setDescription(row.description || "");
      issueDescToShow = row.issue_description || "";
      createdRecordId = row.issue_product_id; // ✅ Use its own ID
    } else {
      // ✅ Case 2: Issued / Partial Return / Return → find latest Created
      const latestCreatedRecord = data
        .filter(
          (item) =>
            item.description === "Created" &&
            item.product_id === row.product_id &&
            item.issued_to_staff_id === row.issued_to_staff_id,
        )
        .sort((a, b) => b.issue_product_id - a.issue_product_id)[0];

      setDescription(row.description || "");

      if (latestCreatedRecord) {
        // 🟢 Created exists → show that description and save its ID
        issueDescToShow = latestCreatedRecord.issue_description || "";
        createdRecordId = latestCreatedRecord.issue_product_id; // ✅ Get Created record's ID
      } else {
        // 🔴 No Created → clear description
        issueDescToShow = "";
      }
    }

    setIssueDescriptions(issueDescToShow);
    setDescriptions(row.description);
    setStatusCreatedId(row.issue_product_status);

    console.log(
      "rw issue description clicked in parent",
      row.issue_description,
    );
    console.log("Created record ID to update:", createdRecordId); // ✅ Log for debugging

    setDeleteData((prevData) => {
      if (Array.isArray(prevData)) {
        return [...prevData, row];
      }
      return [row];
    });

    setDeleteFlag(true);
    setSelectedData(row);
    setStaffId1(row.issued_to_staff_id || "Unknown ID");
    setStaffName(`${row.first_name || ""} ${row.last_name || ""}`);
    setRoleName(row.grade_name || row.role_name);
    setSelectedIssueProductId(row.issue_product_id); // Keep this for display
    setCreatedStatusId(createdRecordId); // ✅ Store the Created record's ID separately
    setOpenComponent(true);
  };

  const handleCloseComponent = () => {
    setOpenComponent(false);
    setOpenComponentCreateSale(false);
    setOpenComponentRefundSale(false);
    setStaffId1("");
    setIssueDescriptions(""); // ✅ Add this line
    setSelectedIssueProductId(null);
    setStaffName("");
    getSales();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const openList = (issueProductId) => {
    setSelectedIssueProductId(issueProductId);
    console.log("issueProductId", issueProductId);

    // Fetch product data first
    getProduct(issueProductId);
    // Then open the dialog
    setOpen(true);
  };

  useEffect(() => {
    getProduct(selectedIssueProductId);
  }, [selectedIssueProductId]);

  const getProduct = async (issueProductId) => {
    console.log("res", issueProductId);
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/issueProduct/getProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            issue_product_id: issueProductId,
          }),
        },
      );

      // If the response status is 401, call signOut
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Product API response:", data);

      // Only update the product state after data is fetched
      if (data.length > 0) {
        setProduct(data);
      }
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };

  const handleCheckboxClick = (row) => {
    console.log("che", row);

    // Handle different statuses
    if (row.description === "Created") {
      setDialogMessage(
        `Are you sure you want to update status for Indent ID ${row.issue_product_id} from "Created" to "Issued"?`,
      );
      setDialogType("confirmation");
    }

    // Store the sales ID for use later
    setSelectedIssueProductId(row.issue_product_id);

    console.log("Row Sales Id:", row.issue_product_id);

    // ✅ Check if sales_details exists before mapping
    if (!row.sales_details || row.sales_details.length === 0) {
      console.warn("⚠️ No sales details found for this row.");
      setTotalProduct([]);
      setTotalQuantity([]);
      setTotalStockQuantity([]);
      return;
    }

    // ✅ Extract product IDs, quantities, and stock correctly
    const productIds = row.sales_details.map((item) => item.product_id);
    const quantities = row.sales_details.map((item) => item.issue_quantity);
    const stocks = row.sales_details.map((item) => item.product_quantity);

    console.log("Product IDs:", productIds);
    console.log("Quantities:", quantities);
    console.log("Stocks:", stocks);

    // ✅ Check for out-of-stock products
    const outOfStockIndex = stocks.findIndex((stock) => stock <= 0);
    if (outOfStockIndex !== -1 && row.description === "Created") {
      setDialogMessage(
        `Products cannot be issued as stock is not available for Product ID ${productIds[outOfStockIndex]}.`,
      );
      setDialogType("error");
      setDialogOpen(true);
      return;
    }

    // ✅ Store in state
    setTotalProduct(productIds);
    setTotalQuantity(quantities);
    setTotalStockQuantity(stocks);

    // ✅ Open the dialog
    setDialogOpen(true);
  };

  const updateSaleStatus = async (issueProductId) => {
    console.log("issueProductId", issueProductId);
    try {
      const productIds = totalProduct;
      const quantities = totalQuantity;
      const stocks = totalStockQuantity;

      console.log("productIds", productIds);

      // ✅ Find the current description from the data
      const currentRecord = data.find(
        (row) => row.issue_product_id === issueProductId,
      );
      const currentDescription = currentRecord?.issue_description || "";

      const payload = {
        issue_product_id: issueProductId,
        updated_by: userId,
        updated_timestamp: new Date(),
        issue_product_status: issuedStatusId,
        issue_description: currentDescription, // ✅ Preserve the description instead of clearing it
        product_id: productIds,
        stock: stocks,
        quantity: quantities,
        issue_date: new Date(),
        issued_by: userId,
      };

      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/updateSaleStatus`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(
          `HTTP error while updating sale status! Status: ${response.status}, Message: ${errorResponse.message}`,
        );
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error updating sale status:", error);
      return null;
    }
  };
  const handleDialogConfirm = async () => {
    const result = await updateSaleStatus(selectedIssueProductId);

    if (result) {
      console.log("Sale status updated successfully:", result);
      await getSales(); // ✅ Wait for data to refresh
    } else {
      console.error("Failed to update sale status.");
    }

    setDialogOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
  };

  useEffect(() => {
    getSales();
  }, []);

  useEffect(() => {
    getSales();
  }, [academicYearId]);

  useEffect(() => {
    getSales();
  }, [academicYearId, statusId, needsReturn]);

  const getSales = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/issueProduct/getSales",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            academic_year_id: academicYearId,
            issue_product_status: statusId ? statusId : null,
            needs_return: needsReturn ? needsReturn : null,
            // issue_description: description ? description : null, // ✅ Added here
          }),
        },
      );

      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return;
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();

      if (Array.isArray(responseData)) {
        setData(responseData);
        console.log("responseData with issue_description:", responseData);
      } else {
        console.error("Response is not an array:", responseData);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  //Added Sorting and Pagination
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting comparator
  const comparator = (a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    }
    return a[orderBy] > b[orderBy] ? -1 : 1;
  };

  const filteredData = data.filter((row) => {
    const searchTerm = search.trim().toLowerCase(); // Trim spaces and convert search term to lowercase

    // Check if the search term is empty to include all rows
    if (!searchTerm) return true;

    // Split the search term into words
    const searchWords = searchTerm.split(/\s+/); // Split by spaces

    // Check if all search words are included in any of the fields
    return searchWords.every((word) => {
      return (
        (row.first_name?.toLowerCase() || "").includes(word) ||
        (row.last_name?.toLowerCase() || "").includes(word) ||
        (row.father_name?.toLowerCase() || "").includes(word) ||
        (row.mother_name?.toLowerCase() || "").includes(word) ||
        (row.guardian_name?.toLowerCase() || "").includes(word) ||
        (row.name?.toLowerCase() || "").includes(word) ||
        (row.isuue_date?.toString() || "").includes(word) ||
        (row.sale_date?.toString() || "").includes(word) ||
        (row.contact_no?.toString() || "").includes(word) || // Convert to string for comparison
        (row.sales_id?.toString() || "").includes(word) || // Convert to string for comparison
        (row.description?.toLowerCase() || "").includes(word)
      );
    });
  });

  // Apply sorting to filtered data
  const sortedRows = [...filteredData].sort(comparator);

  // Apply pagination to the sorted data
  const paginatedRows = sortedRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const handleDownload = (row) => {
    // Prevent download if rows are empty or all rows contain no meaningful data
    const isDataEmpty =
      !data ||
      data.length === 0 ||
      data.every(
        (row) =>
          !row.issue_product_id &&
          !`${row.first_name} ${row.last_name}` &&
          !row.contact_no &&
          !row.issue_description &&
          !row.issue_date &&
          !row.issued_by &&
          !row.return_date &&
          !row.description,
      );

    if (isDataEmpty) {
      return;
    }
    const institute = getInstituteConfig(instituteId);

    const doc = new jsPDF();

    // Header background
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 9, 1, 28, 18);
    }

    // School Name
    const textStartY = 11;
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text(institute.name, doc.internal.pageSize.getWidth() / 2, textStartY, {
      align: "center",
    });

    // Address
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" },
    );
    doc.text(
      institute.address2,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 18,
      { align: "center" },
    );
    if (institute.tel) {
      doc.text(
        institute.tel,
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 22,
        { align: "center" },
      );
    }
    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 36; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "ISSUE PRODUCT REPORT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" },
    ); // Center aligned title
    doc.setFontSize(10);

    //Constants for alignment
    const studentLabelX = 14;

    // Constants for alignment and padding
    const pageWidth = doc.internal.pageSize.getWidth(); // Get the width of the PDF page
    const rightPadding = 14; // Padding from the right edge

    // Add Grade, Fees Slab, Pending Fees, and Section dynamically
    const studentDetailsY = receiptTextY + 10;

    // Set font for student name and details
    doc.setFont("helvetica", "bold");
    // --- Add Current Date on the Right Side ---
    // Get the current date
    const today = new Date();
    const currentDate = today.toLocaleDateString("en-GB"); // Format as DD-MM-YYYY

    // Set font for the "Date:" label
    doc.setFont("helvetica", "bold");

    // Get the width of the "Date:" label and the date text
    const dateLabel = "Date: ";
    const dateLabelWidth = doc.getTextWidth(dateLabel);
    const dateWidth = doc.getTextWidth(currentDate);

    // Calculate the X position for the date label (right aligned)
    const dateXPosition = pageWidth - rightPadding - dateWidth - dateLabelWidth; // Position the "Date:" label with padding from the right

    // Add the "Date:" label to the document
    doc.text(dateLabel, dateXPosition, studentDetailsY); // Add the "Date:" label

    // Set font to normal for the actual date
    doc.setFont("helvetica", "normal");
    doc.text(currentDate, dateXPosition + dateLabelWidth, studentDetailsY);

    // Prepare table data - FIXED: removed duplicate issue_description
    const tableData = data.map((row) => [
      row.issue_product_id,
      `${row.first_name} ${row.last_name}`,
      row.contact_no,
      row.issue_description || "",
      row.issue_date || "", // This will now show in the "Issued Date" column
      row.issued_by || "",
      row.return_date || "",
      row.description || "",
    ]);

    // Table settings
    doc.autoTable({
      head: [
        [
          "Indent ID",
          "Staff Name",
          "Contact No",
          "Description",
          "Issued Date",
          "Issued By",
          "Return Date",
          "Status",
        ],
      ],
      body: tableData,
      startY: receiptTextY + 13, // Start table below receipt title
      styles: { fontSize: 8, halign: "center" },
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
      },
      theme: "grid",
    });

    // Save the PDF
    doc.save(
      `issue_product_report_${new Date().toISOString().slice(0, 10)}.pdf`,
    );
  };

  //download reciept
  const handleDownload1 = async (row, event) => {
    event.stopPropagation();
    const doc = new jsPDF();

    const institute = getInstituteConfig(instituteId);

    // Add Logo and Header
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    const textyy = 11;
    doc.setFont("helvetica", "bold");

    // School name
    doc.text(
      institute.name, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textyy,
      { align: "center" },
    );

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 8, 1, 28, 18); // ✅ dynamic
    }

    // Address
    doc.setTextColor(0, 0, 0);
    const textStartY = 15;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 10,
      { align: "center" },
    );
    doc.text(
      institute.address2, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" },
    );
    if (institute.tel) {
      doc.text(
        institute.tel, // ✅ dynamic, skipped for JPS
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 18,
        { align: "center" },
      );
    }

    // Add Receipt Title, Number, and Date
    const receiptTextY = textStartY + 30;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    if (
      row.description === "Issued" ||
      row.description === "Returned" ||
      row.description === "Partial Return"
    ) {
      doc.text(
        "ISSUE PRODUCT RECEIPT",
        doc.internal.pageSize.getWidth() / 2,
        receiptTextY,
        { align: "center" },
      );
    }
    doc.setFontSize(10);
    const studentDetailsY = receiptTextY + 10;

    // Set font for student name and details
    doc.setFont("helvetica", "bold");
    const studentLabelX = 14;

    // Constants for padding and maximum widths
    const PADDING = 5; // Uniform padding between elements
    const MAX_NAME_WIDTH = 70; // Max width for student name before wrapping

    // Handle long student name
    const staffName = `${row.first_name || ""} ${row.last_name || ""}`.trim(); // Combine first name and last name
    const staffNameWidth = doc.getTextWidth(staffName);
    const splitstaffName =
      staffNameWidth > MAX_NAME_WIDTH
        ? doc.splitTextToSize(staffName, MAX_NAME_WIDTH)
        : staffName;

    doc.text(`Name of Staff Member: `, studentLabelX, studentDetailsY); // Left aligned
    doc.setFont("helvetica", "normal");
    doc.text(splitstaffName, studentLabelX + 40, studentDetailsY); // Adjust X position for student name

    // Dynamically calculate X position for Grade based on student name
    const staffNameActualWidth = Math.min(staffNameWidth, MAX_NAME_WIDTH); // Use actual width or max width
    const gradeX = studentLabelX + 30 + staffNameActualWidth + PADDING;

    // Table for Particulars
    const receiptDetails = [
      { title: "Intend ID", value: row.issue_product_id },
      { title: "Staff Name", value: staffName },
      { title: "Contact No", value: row.contact_no },
      { title: "Description", value: row.issue_description },

      { title: "Issue Date", value: row.issue_date },
      {
        title: "Issued By",
        value:
          row.description === "Issued" ||
          row.description === "Returned" ||
          row.description === "Partial Return"
            ? row.issued_by
            : "",
      },
      { title: "Return Date", value: row.return_date },

      { title: "Status", value: row.description },
    ];

    // Initialize product-related values
    let saleProductsValue = "";
    let refundProductsValue = "";

    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/issueProduct/getProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ issue_product_id: row.issue_product_id }),
        },
      );

      const productDetails = await response.json();

      if (productDetails.length > 0) {
        productDetails.forEach((product, index) => {
          const productInfo = `${index + 1}. Product: ${product.product_name}, Quantity: ${product.quantity}`;

          const productInfoReturn = `${index + 1}. Product: ${product.product_name}, Quantity: ${
            product.return_quantity > 0
              ? product.return_quantity
              : product.quantity
          }, Return date: ${product.return_date}`;

          if (product.type === "Issued" && product.quantity > 0) {
            // Only add to sale if it hasn't been returned
            saleProductsValue += productInfo + "\n";
          }
          if (
            (product.type === "Issued" && product.return_quantity > 0) ||
            product.type === "Partial Return" ||
            product.type === "Returned"
          ) {
            refundProductsValue += productInfoReturn + "\n";
          }
        });
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    }

    // Add the products based on their type and description
    if (row.description === "Issued") {
      // Show only sale products under "Products Issued"
      receiptDetails.push({
        title: "Products Issued",
        value: saleProductsValue,
      });
    }

    if (row.description === "Returned") {
      // Show only refund products under "Products Refunded"
      receiptDetails.push({
        title: "Products Returned",
        value: refundProductsValue,
      });
    }

    if (row.description === "Partial Return") {
      // Show both "Products Issued" (sale) and "Products Refunded" (refund) separately
      if (saleProductsValue) {
        receiptDetails.push({
          title: "Products Issued",
          value: saleProductsValue,
        });
      }
      if (refundProductsValue) {
        receiptDetails.push({
          title: "Products Returned",
          value: refundProductsValue,
        });
      }
    }

    // Table settings
    doc.autoTable({
      head: [["Particulars", ""]],
      // body: receiptDetails.map((item) => [item.title, item.value]),

      body: receiptDetails.map((item) => {
        if (item.title === "Status") {
          return [
            { content: item.title, styles: { fontStyle: "normal" } }, // Bold title
            { content: item.value, styles: { fontStyle: "bold" } }, // Bold value
          ];
        } else {
          return [item.title, item.value]; // Normal styling for other rows
        }
      }),

      startY: receiptTextY + 13, // Start table below student details
      styles: { fontSize: 10, cellPadding: 2 }, // Adjust padding for consistency
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
        halign: "left", // Center-align header text
      },
      bodyStyles: {
        halign: "left", // Align text to the left in the body
      },
      columnStyles: {
        0: { cellWidth: 70, halign: "left" }, // Fixed width for the "Particulars" column
        1: { cellWidth: 110, halign: "left" }, // Fixed width for the "Amount" column
      },
      theme: "grid",
    });

    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(
      2,
      "0",
    )}/${String(currentDate.getMonth() + 1).padStart(
      2,
      "0",
    )}/${currentDate.getFullYear()}`;

    // Add the text with the current date
    if (
      row.description === "Issued" ||
      row.description === "Returned" ||
      row.description === "Partial Return"
    ) {
      doc.setFont("helvetica", "bold");
      doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
      doc.setFont("helvetica", "bold");
      doc.text("Authorized Signatory", 159, doc.previousAutoTable.finalY + 40);
    }

    // Save the PDF
    if (
      row.description === "Issued" ||
      row.description === "Returned" ||
      row.description === "Partial Return"
    ) {
      doc.save(
        `issue-product-receipt_${new Date().toISOString().slice(0, 10)}.pdf`,
      );
    }
  };

  const handleStatusChange = (event) => {
    setStatusName(event.target.value);
    let selectedStatus = saleStatus.find(
      (fr) => fr.description === event.target.value,
    );
    setStatusId(selectedStatus.issue_product_status_id);
    console.log(
      "selectedStatus.sales_status_id",
      selectedStatus.sales_status_id,
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <Layout />

      <div>
        <h1 className="sales-title">Issue Products for Staff</h1>
      </div>
      {/* <br /> */}
      <div className="fees_report_box">
        <Stack spacing={4} direction="row">
          <Stack direction="row" spacing={2} alignItems="center">
            {" "}
            {/* Search Box */}
            <Box component="form" className="search-box">
              <TextField
                label="Search..."
                variant="outlined"
                fullWidth
                value={search}
                onChange={(event) => {
                  setSearch(event.target.value);
                  setPage(0); // Reset to first page
                }}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ minWidth: 100 }}>
              <FormControl sx={{ minWidth: 100 }} size="small">
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={statusName}
                  label="Grade"
                  onChange={handleStatusChange}
                >
                  {saleStatus.map((s) => (
                    <MenuItem key={s.description} value={s.description}>
                      {s.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box className="pending-fees-switch">
              <FormControlLabel
                control={
                  <Switch
                    onChange={handleRTEChange}
                    defaultChecked={needsReturn}
                  />
                }
                label="No Return"
              />
            </Box>
          </Stack>
          <div className="download-report-box-fees-report">
            <Button
              onClick={() => handleOpenComponentCreateSale()}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginRight: "5px",
              }}
            >
              {" "}
              Issue Product{" "}
            </Button>
            <Button
              className="create-sale-btn"
              // sx={{background:'#0A64A2',padding:"7.5px"}}
              variant="contained"
              onClick={handleDownload}
              startIcon={<DownloadIcon />}
            >
              Download Report
            </Button>
          </div>
        </Stack>
      </div>
      {/* <br /> */}

      <Box className="table-container">
        <Box className="table-container">
          <Paper className="table-container-paper">
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 750 }}
                aria-label="custom pagination table"
              >
                <TableHead align="center">
                  <TableRow>
                    <StyledTableCell
                      sortDirection={
                        orderBy === "issue_product_id" ? order : false
                      }
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issue_product_id"}
                        direction={
                          orderBy === "issue_product_id" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("issue_product_id")}
                      >
                        Indent ID
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sortDirection={orderBy === "first_name" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "first_name"}
                        direction={orderBy === "first_name" ? order : "asc"}
                        onClick={() => handleRequestSort("first_name")}
                      >
                        Staff Name
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "34px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "contact_no"}
                        direction={orderBy === "contact_no" ? order : "asc"}
                        onClick={() => handleRequestSort("contact_no")}
                      >
                        Contact No
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "34px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issue_description"}
                        direction={
                          orderBy === "issue_description" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("issue_description")}
                      >
                        Description
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issue_date"}
                        direction={orderBy === "issue_date" ? order : "asc"}
                        onClick={() => handleRequestSort("issue_date")}
                      >
                        Issue Date
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issued_by"}
                        direction={orderBy === "issued_by" ? order : "asc"}
                        onClick={() => handleRequestSort("issued_by")}
                      >
                        Issued By
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "return_date"}
                        direction={orderBy === "return_date" ? order : "asc"}
                        onClick={() => handleRequestSort("return_date")}
                      >
                        Return Date
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell align="center" className="sales_tablecell">
                      <TableSortLabel
                        active={orderBy === "description"}
                        direction={orderBy === "description" ? order : "asc"}
                        onClick={() => handleRequestSort("description")}
                      >
                        Status
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Issued
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Product
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Action
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Return
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Receipt
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {paginatedRows.map((row) => (
                      <StyledTableRow
                        style={{ cursor: "pointer", textAlign: "center" }}
                        key={row.sales_id}
                        tabIndex={-1}
                        padding="none"
                      >
                        <StyledTableCell
                          component="th"
                          scope="row"
                          padding="none"
                          align="center"
                          className="table_content"
                        >
                          {row.issue_product_id}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.first_name} {row.last_name}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.contact_no}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          sx={{ p: 0, borderBottom: "none" }} // 🔹 removes the white line
                        >
                          <Tooltip
                            title={
                              row.issue_description ? row.issue_description : ""
                            } // ✅ This shows OLD description
                            placement="top"
                          >
                            <IconButton
                              size="small"
                              sx={{
                                color: "#0A64A2",
                                p: 0.3,
                                "&:hover": { backgroundColor: "transparent" },
                              }}
                            >
                              <InfoIcon fontSize="medium" sx={{ ml: 0.2 }} />
                            </IconButton>
                          </Tooltip>
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.issue_date}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.issued_by}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.return_date}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.description}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ padding: "0" }}
                        >
                          <Checkbox
                            checked={
                              row.description === "Issued" ||
                              row.description === "Returned" ||
                              row.description === "Partial Return"
                            }
                            disabled={
                              row.description === "Issued" ||
                              row.description === "Returned" ||
                              row.description === "Partial Return"
                            }
                            onChange={() => handleCheckboxClick(row)}
                            style={{ marginTop: "5px" }}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ padding: "0" }}
                        >
                          <ListAltIcon
                            style={{
                              marginLeft: "8px",
                              marginTop: "9px",
                              color: "#0A64A2",
                            }}
                            onClick={() => openList(row.issue_product_id)} // Pass the sales_id here
                          />
                          {/* Add some margin for spacing */}
                          {/* Product List Dialog */}
                          <Dialog
                            open={open}
                            onClose={handleClose}
                            maxWidth="lg"
                            fullWidth={false}
                            PaperProps={{
                              style: { maxHeight: "90vh", boxShadow: "0" },
                            }}
                            BackdropProps={{
                              style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
                            }}
                          >
                            <IconButton
                              onClick={handleClose}
                              style={{
                                color: "#817575",
                                position: "absolute",
                                right: "4px",
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                            <Box>
                              <DialogTitle
                                style={{
                                  color: "#0A64A2",
                                  padding: "0px 11px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "0",
                                  marginTop: "15px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <ListAltIcon
                                    style={{
                                      paddingBottom: "0",
                                      marginTop: "7px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      marginLeft: "8px",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Product List for Indent Id{" "}
                                    {selectedIssueProductId}
                                  </span>
                                </div>
                              </DialogTitle>
                            </Box>
                            <Divider
                              className="divider"
                              style={{ width: "94%", marginLeft: "13px" }}
                            />
                            <DialogContent
                              style={{
                                padding: "0",
                                margin: "0px 10px",
                                marginBottom: "10px",
                              }}
                            >
                              {[
                                "Created",
                                hasPartialReturn ? "Partial Return" : "Issued",
                                "Returned",
                              ].map((type) => {
                                const filteredProducts = product.filter(
                                  (p) =>
                                    p.issue_product_id ===
                                      selectedIssueProductId &&
                                    (hasPartialReturn
                                      ? type !== "Issued" &&
                                        type === "Partial Return"
                                      : p.type === type),
                                );

                                return filteredProducts.length > 0 ? (
                                  <div
                                    key={type}
                                    style={{ marginBottom: "4px" }}
                                  >
                                    <h4
                                      style={{
                                        color: "#0A64A2",
                                        marginBottom: "0px",
                                        marginTop: "3px",
                                        marginLeft: "2px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {type === "Created"
                                        ? ""
                                        : type === "Issued" &&
                                            filteredProducts.every(
                                              (p) => p.return_quantity === 0,
                                            )
                                          ? "Issued Products"
                                          : type === "Partial Return" ||
                                              (type == "Issued" &&
                                                filteredProducts.some(
                                                  (p) => p.return_quantity > 0,
                                                ))
                                            ? "Partially Returned Products"
                                            : "Returned Products"}
                                    </h4>
                                    <Table size="small">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Product Name
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Attribute
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            {type === "Partial Return" ||
                                            type === "Returned" ||
                                            type === "Issued"
                                              ? "Issued Quantity"
                                              : "Quantity"}
                                          </TableCell>

                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            {type === "Partial Return" ||
                                            type === "Returned" ||
                                            (type === "Issued" &&
                                              filteredProducts.some(
                                                (p) => p.return_quantity > 0,
                                              ))
                                              ? "Return Quantity"
                                              : ""}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {filteredProducts.map((p) => (
                                          <TableRow
                                            key={p.issue_product_details_id}
                                          >
                                            <TableCell
                                              align="left"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.product_name}
                                            </TableCell>
                                            <TableCell
                                              align="left"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.attribute_value}
                                            </TableCell>

                                            <TableCell
                                              align="center"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.quantity + p.return_quantity}
                                            </TableCell>

                                            {/* {type !== "Created" && type !== "Issued" &&  (
        <TableCell align="center" style={{ padding: "4px" }}>{p.return_quantity}</TableCell>
         )} */}

                                            {type !== "Created" &&
                                              (type !== "Issued" ||
                                                filteredProducts.some(
                                                  (p) => p.return_quantity > 0,
                                                )) && (
                                                <TableCell
                                                  align="center"
                                                  style={{ padding: "4px" }}
                                                >
                                                  {p.return_quantity}
                                                </TableCell>
                                              )}
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </div>
                                ) : null;
                              })}

                              {product.filter(
                                (p) =>
                                  p.issue_product_id === selectedIssueProductId,
                              ).length === 0 && (
                                <p
                                  style={{
                                    margin: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  No products available.
                                </p>
                              )}
                            </DialogContent>
                          </Dialog>
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                          onClick={() => handleOpenComponent(row)}
                          style={{ padding: "0" }}
                        >
                          {row.description === "Created" ? (
                            <Tooltip
                              title="Edit Product"
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "white",
                                    color: "rgb(0 0 0 / 90%)",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 6px rgba(65, 61, 61, 0.1)",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                            >
                              <img
                                src={editProductIcon}
                                alt="Edit Product Icon"
                                style={{ height: "30px", marginBottom: "-2px" }}
                              />
                            </Tooltip>
                          ) : row.description === "Issued" ||
                            row.description === "Returned" ||
                            row.description === "Partial Return" ? (
                            <Tooltip
                              title="Issue Product"
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "white",
                                    color: "rgb(0 0 0 / 90%)",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 6px rgba(65, 61, 61, 0.1)",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                            >
                              <img
                                src={issueProductIcon}
                                alt="Add Product Icon"
                                style={{ height: "30px", marginBottom: "-2px" }}
                              />
                            </Tooltip>
                          ) : null}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                          style={{ padding: "0" }}
                        >
                          {row.description === "Issued" ||
                          row.description === "Partial Return" ? (
                            <Tooltip
                              title="Return Product"
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "white",
                                    color: "rgb(0 0 0 / 90%)",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 6px rgba(65, 61, 61, 0.1)",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                            >
                              <img
                                src={returnProductIcon}
                                alt="Return Product Icon"
                                style={{
                                  height: "30px",
                                  marginBottom: "-2px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(row)}
                              />
                            </Tooltip>
                          ) : (
                            <img
                              src={returnProductIcon}
                              alt="Return Product Icon"
                              style={{
                                height: "30px",
                                marginBottom: "-2px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(row)}
                            />
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <Button
                            variant="text"
                            onClick={(event) => handleDownload1(row, event)}
                            startIcon={<DownloadIcon />}
                            style={{ padding: "0" }}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                )}
                <TableFooter className="table-footer">
                  <TableRow className="table-header">
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      count={sortedRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className="table-pagination"
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {dialogType === "confirmation" ? (
            <>
              <Button
                variant="contained"
                onClick={handleDialogConfirm}
                className="no-btn"
              >
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={handleDialogClose}
                autoFocus
                className="no-btn"
              >
                No
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={handleDialogClose}
              autoFocus
              className="no-btn"
            >
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Popup Component */}
      <Dialog
        open={openComponent}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div className="icon-btn">
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        {selectedData && (
          <div
            className="main_title"
            style={{ paddingLeft: "26px", paddingBottom: "1px" }}
          >
            {selectedData.description === "Created" ? (
              <>
                <img
                  src={editProductIcon}
                  alt="editProductIcon"
                  style={{ height: "30px", marginBottom: "-4px" }}
                />
                <span className="create-sale">Edit Product</span>
              </>
            ) : selectedData.description === "Paid" ||
              selectedData.description === "Issued" ||
              selectedData.description === "Returned" ||
              selectedData.description === "Partial Return" ? (
              <>
                <img
                  src={issueProductIcon}
                  alt="issueProductIcon"
                  style={{ height: "30px", marginBottom: "-4px" }}
                />
                <span className="create-sale">Issue Product</span>
              </>
            ) : null}
          </div>
        )}

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />
        <DialogContent>
          {/* Replace with your CreateSale component */}
          <CreateProduct
            staffId1={staffId1}
            staffName={staffName}
            selectedIssueProductId={selectedIssueProductId}
            setSelectedIssueProductId={setSelectedIssueProductId}
            roleName={roleName}
            deleteFlag={deleteFlag}
            deleteData={deleteData}
            setOpenComponent={setOpenComponent}
            setOpenComponentCreateSale={setOpenComponentCreateSale}
            getSales={getSales}
            statusCreatedId={statusCreatedId}
            issueDescription={IssueDescriptions} // Add this prop
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openComponentCreateSale}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px",
            paddingBottom: "0",
            paddingTop: "0",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div
          className="main_title"
          style={{ paddingLeft: "26px", paddingBottom: "1px" }}
        >
          <img
            src={issueProductIcon}
            alt="issueProductIcon"
            style={{ height: "30px", marginBottom: "-4px" }}
          />
          <span className="create-sale">Issue Product</span>
        </div>

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />
        <DialogContent>
          {/* Replace with your CreateSale component */}
          <CreateProduct
            staffId1={staffId1}
            staffName={staffName}
            selectedIssueProductId={selectedIssueProductId}
            setSelectedIssueProductId={setSelectedIssueProductId}
            roleName={roleName}
            deleteFlag={deleteFlag}
            deleteData={deleteData}
            setOpenComponent={setOpenComponent}
            setOpenComponentCreateSale={setOpenComponentCreateSale}
            getSales={getSales}
            statusCreatedId={statusCreatedId}
            issueDescription={IssueDescriptions}
            SelectedEventId={SelectedEventId}
            data={data}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openComponentRefundSale}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px",
            paddingBottom: "0",
            paddingTop: "0",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div
          className="main_title"
          style={{ paddingLeft: "26px", paddingBottom: "1px" }}
        >
          <img
            src={returnProductIcon}
            alt="returnProductIcon"
            style={{ height: "30px", marginBottom: "-4px" }}
          />
          <span className="create-sale">Return Product</span>
        </div>

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />
        <DialogContent>
          {/* Replace with your CreateSale component */}
          <ReturnProduct
            staffId1={staffId1}
            staffName={staffName}
            setOpenComponentRefundSale={setOpenComponentRefundSale}
            getSales={getSales}
            selectedIssueProductId={selectedIssueProductId}
            roleName={roleName}
          />
        </DialogContent>
      </Dialog>

      {/* Dialog Popup */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessageForReturn}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setOpenDialog(false)}
            autoFocus
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
